import slugify from "./sport/slugify";
import { useSettings } from "~/store/settings";
import { useBetbook } from "~/store/betbook";
import type { IEvent } from "~/types/sports/event";

const getJerserySrc = (isHome: boolean, eventId: number, hasJersey: boolean, customEvent?: IEvent) => {
	const store = useBetbook();
	const event = customEvent ? customEvent : store.events.get(eventId);

	if (!event || !hasJersey)
		return "https://media.betwayafrica.com/medialibraries/content.gmgamingsystems.com/synapse/team-jerseys/fallback-items/football.svg";

	if (isHome) {
		return `https://media.betwayafrica.com/medialibraries/content.gmgamingsystems.com/synapse/team-jerseys/${
			event.sportId.replace("---", "-") || "default"
		}/${slugify(event.homeTeam)}.svg`;
	}

	return `https://media.betwayafrica.com/medialibraries/content.gmgamingsystems.com/synapse/team-jerseys/${
		event.sportId.replace("---", "-") || "default"
	}/${slugify(event.awayTeam)}.svg`;
};

const hasLeagueJersey = (leagueId?: string, regionId?: string) => {
	if (!regionId || !leagueId) return false;

	const settings = useSettings();
	const configJerseys = settings.config?.devConfig.teamJerseysAvailable || [];
	const regionLeaguesMap = new Map<string, string[]>();

	for (let i = 0; i < configJerseys.length; i++) {
		const element = configJerseys[i];

		const existingMapLeagues = Array.from(regionLeaguesMap.get(element.split("_")[0])?.values() || []);
		existingMapLeagues.push(element.split("_")[1]);

		regionLeaguesMap.set(element.split("_")[0], existingMapLeagues);
	}

	if (regionLeaguesMap.has(regionId) && Array.from(regionLeaguesMap.get(regionId)?.values() || []).includes(leagueId)) {
		return true;
	}

	return false;
};

const handleTeamJerseyError = (e: Event, teamName: string, sportId: string) => {
	const target = e.target as HTMLImageElement;
	if (!target) return;
	const fallbackSportId = sportId === "soccer" ? "football" : sportId.replace("---", "-");
	target.src = `https://cdn.betwayafrica.com/Betway/team-jerseys/fallback-items/${fallbackSportId}.svg`;

	target.onerror = () => {
		target.src = "https://cdn.betwayafrica.com/Betway/team-jerseys/fallback-items/football.svg";
	};
};

export { getJerserySrc, hasLeagueJersey, handleTeamJerseyError };
